import { store } from 'store/configureStore';
import apiSauce from 'apisauce';
import _ from 'lodash';
import * as accountActions from '../actions/account'
import { actions } from '../actions/account/actionTypes'
import { logout } from './profile.services';


interface FailRequest {
  url: string,
  params: any,
  method: string
  resolve: any,
  reject: any
}

let isRefreshing: boolean = false
let QueueFailRequest: FailRequest[] = []

let HEADERS: any = {
  Accept: 'application/json',
  'Content-Type': 'application/json;charset=utf-8',
};

let HEADERS_MULTIPLE_PART: any = {
  Accept: 'application/json',
  'Content-Type': 'multipart/form-data',
};

const setToken = () => {
  const { user } = store.getState();
  const access_token = user?.data?.access_token;

  HEADERS = {
    ...HEADERS,
    Authorization: 'Bearer ' + access_token,
  };
  HEADERS_MULTIPLE_PART = {
    ...HEADERS_MULTIPLE_PART,
    Authorization: 'Bearer ' + access_token,
  };
};

const setTokenRefresh = () => {
  const { user } = store.getState();
  const refresh_token = user?.data?.refresh_token;

  HEADERS = {
    ...HEADERS,
    Authorization: 'Bearer ' + refresh_token,
  };
}

export const apiGlobal = apiSauce.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  timeout: 1000000,
  headers: HEADERS,
});

const refreshAccessToken = async (method: string, url: string, params: string, resolve: any, reject: any) => {
  if (!isRefreshing) {
    isRefreshing = true
    await store.dispatch(accountActions.refreshToken());
  }
  QueueFailRequest.push({ method, url, params, resolve, reject })
}

const resolveQueueFailRequest = () => {
  Promise.all(QueueFailRequest.map(failRequest => {
    switch (failRequest.method) {
      case 'authGet':
        api.authGet(failRequest.url, failRequest.params).then(res => failRequest.resolve(res))
        break;
      case 'authDelete':
        api.authDelete(failRequest.url, failRequest.params).then(res => failRequest.resolve(res))
        break;
      case 'authPost':
        api.authPost(failRequest.url, failRequest.params).then(res => failRequest.resolve(res))
        break;
      case 'authPut':
        api.authPut(failRequest.url, failRequest.params).then(res => failRequest.resolve(res))
        break;
      case 'authPutForm':
        api.authPutForm(failRequest.url, failRequest.params).then(res => failRequest.resolve(res))
        break;
      case 'authPostForm':
        api.authPostForm(failRequest.url, failRequest.params).then(res => failRequest.resolve(res))
        break;
    }
  })).then(res => {
    QueueFailRequest = []
  })
}

const api = {
  refreshToken: (url: string) => {
    setTokenRefresh();
    apiGlobal.setHeaders(HEADERS);
    return apiGlobal.post(url).then((res: any) => {

      if (process.env.REACT_APP_NODE_ENV !== "production") {
        console.log('=== refresh token res: ', res);
      }
      if (res?.status >= 200 && res?.status < 300) {
        isRefreshing = false
        store.dispatch(actions.refreshTokenSuccess(res?.data))
        resolveQueueFailRequest()
        return Promise.resolve(res?.data);
      } else {
        logout()
        return Promise.reject(res);
      }
    });
  },

  authGet: (url: string, params: any = {}) => {
    setToken();
    apiGlobal.setHeaders(HEADERS);
    return apiGlobal.get(url, params).then((res: any) => {
      if (process.env.REACT_APP_NODE_ENV !== "production") {
        console.log('=== authGet res: ', res);
      }
      if (res?.status === 401) {
        return new Promise((resolve, reject) => {
          refreshAccessToken('authGet', url, params, resolve, reject)
        }).then(res => {
          return res
        }).catch(err => {
          console.log("err");
        })
      } else if (res?.status >= 200 && res?.status < 300) {
        return Promise.resolve(res?.data);
      } else {
        return Promise.reject(res?.data);
      }
    });
  },

  authDelete: (url: string, params: any = {}) => {
    setToken();
    apiGlobal.setHeaders(HEADERS);
    return apiGlobal.delete(url, params).then((res: any) => {
      if (process.env.REACT_APP_NODE_ENV !== "production") {
        console.log('=== authGet res: ', res);
      }
      if (res?.status === 401) {
        return new Promise((resolve, reject) => {
          refreshAccessToken('authDelete', url, params, resolve, reject)
        }).then(res => {
          return res
        }).catch(err => {
          console.log("err");
        })
      } else if (res?.status >= 200 && res?.status < 300) {
        return Promise.resolve(res?.data);
      } else {
        return Promise.reject(res?.data);
      }
    });
  },

  authPost: (url: string, data: any = {}) => {
    setToken();
    apiGlobal.setHeaders(HEADERS);
    return apiGlobal.post(url, data).then((res: any) => {
      if (process.env.REACT_APP_NODE_ENV !== "production") {
        console.log('=== authPost res: ', res);
      }
      if (res?.status === 401) {
        return new Promise((resolve, reject) => {
          refreshAccessToken('authPost', url, data, resolve, reject)
        }).then(res => {
          return res
        }).catch(err => {
          console.log("err");
        })
      } else if (res?.status >= 200 && res?.status < 300) {
        return Promise.resolve(res?.data);
      } else {
        return Promise.reject(res?.data);
      }
    });
  },

  authPut: (url: string, data: any = {}) => {
    setToken();
    apiGlobal.setHeaders(HEADERS);
    return apiGlobal.put(url, data).then((res: any) => {
      if (process.env.REACT_APP_NODE_ENV !== "production") {
        console.log('=== authPut res: ', res);
      }
      if (res?.status === 401) {
        return new Promise((resolve, reject) => {
          refreshAccessToken('authPut', url, data, resolve, reject)
        }).then(res => {
          return res
        }).catch(err => {
          console.log("err");
        })
      } else if (res?.status >= 200 && res?.status < 300) {
        return Promise.resolve(res?.data);
      } else {
        return Promise.reject(res?.data);
      }
    });
  },

  authPutForm: (url: string, params: any) => {
    const formData = new FormData();
    formData.append('_method', 'PUT');
    _.forIn(params, (value, key) => {
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            for (var keyObj in value[i]) {
              formData.append(`${key}[${i}][${keyObj}]`, value[i][keyObj]);
            }
          }
        } else {
          formData.append(key, value);
        }
      }
    });
    setToken();
    apiGlobal.setHeaders(HEADERS_MULTIPLE_PART);
    return apiGlobal.post(url, formData).then((res: any) => {
      if (process.env.REACT_APP_NODE_ENV !== "production") {
        console.log('=== authPutForm res: ', res);
      }
      if (res?.status === 401) {
        return new Promise((resolve, reject) => {
          refreshAccessToken('authPutForm', url, params, resolve, reject)
        }).then(res => {
          return res
        }).catch(err => {
          console.log("err");
        })
      } else if (res?.status >= 200 && res?.status < 300) {
        return Promise.resolve(res?.data);
      } else {
        console.error("API Error - authPutForm:", {
          url,
          status: res?.status,
          data: res?.data,
          problem: res?.problem,
          params: params
        });
        return Promise.reject(res?.data);
      }
    });
  },

  authPostForm: (url: string, params: any) => {
    const formData = new FormData();
    _.forIn(params, (value, key) => {
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            for (var keyObj in value[i]) {
              formData.append(`${key}[${i}][${keyObj}]`, value[i][keyObj]);
            }
          }
        } else {
          formData.append(key, value);
        }
      }
    });
    setToken();
    console.log(HEADERS_MULTIPLE_PART);
    apiGlobal.setHeaders(HEADERS_MULTIPLE_PART);
    return apiGlobal.post(url, formData).then((res: any) => {
      if (process.env.REACT_APP_NODE_ENV !== "production") {
        console.log('=== authPostForm res: ', res);
      }
      if (res?.status === 401) {
        return new Promise((resolve, reject) => {
          refreshAccessToken('authPostForm', url, params, resolve, reject)
        }).then(res => {
          return res
        }).catch(err => {
          console.log("err");
        })
      } else if (res?.status >= 200 && res?.status < 300) {
        return Promise.resolve(res?.data);
      } else {
        return Promise.reject(res?.data);
      }
    });
  },
};

export { api };
